import React from 'react';
import Skeleton, { SkeletonProps, SkeletonTheme } from 'react-loading-skeleton';

const DarkSkeleton: React.FC<SkeletonProps> = ({ ...rest }) => (
    <SkeletonTheme baseColor="#F7F4F2" highlightColor="#FFFFFF">
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Skeleton {...rest} />
    </SkeletonTheme>
);

export default DarkSkeleton;
